import React from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { connect } from 'react-redux';
import { data as categories } from '@lba-dev/package.local-globals/categories';
import MenuItem from '@mui/material/MenuItem';

import { setDialogContentProp } from '../../actions/dialog';
import { buildDemandePhotoMessage } from '../../actions/general';
import CustomSelect from '../CustomInputs/CustomSelect';

const setCategorie = setDialogContentProp('categorie');
const setZipCode = setDialogContentProp('zipCode');
const setTel = setDialogContentProp('tel');
const setMessage = setDialogContentProp('message');
const setAutoMessage = setDialogContentProp('autoMessage');

const mapStateToProps = ({
  dialog: {
    contentProps: {
      tel, categorie, zipCode, message, autoMessage
    },
  },
  connectedUser: { alias },
}) => ({
  tel,
  categorie,
  zipCode,
  message,
  autoMessage,
  alias,
});

const mapDispatchToProps = {
  setTel,
  setCategorie,
  setZipCode,
  setMessage,
  setAutoMessage
};

const DemandePhoto = ({
  tel,
  zipCode,
  categorie,
  message,
  autoMessage,
  alias,
  setTel,
  setCategorie,
  setZipCode,
  setMessage,
  setAutoMessage
}) => {
  // Régénère le message par défaut quand catégorie/code postal changent --
  // mais seulement si l'agent ne l'a pas déjà personnalisé, sinon on
  // écraserait un texte réécrit à la main.
  const applyContext = (nextCategorie, nextZipCode) => {
    if (message !== autoMessage) {
      return;
    }
    const next = buildDemandePhotoMessage(alias, nextCategorie, nextZipCode);
    setMessage(next);
    setAutoMessage(next);
  };

  return (
    <Grid container spacing={4} justifyContent="center" alignItems="flex-end">
      <Grid item xs={6}>
        <CustomSelect
          grid
          xs={12}
          label="Catégorie"
          value={categorie}
          setData={(p, v) => {
            setCategorie(v);
            applyContext(v, zipCode);
          }}
        >
          {categories.map((e) =>
            <MenuItem
              key={`${e.name}-${e._id}`}
              value={e.name}
              children={e.name}
            />
          )}
        </CustomSelect>
      </Grid>
      <Grid item xs={6}>
        <TextField
          variant="standard"
          type={'number'}
          label="Code postal"
          onChange={(e) => {
            setZipCode(e.target.value);
            applyContext(categorie, e.target.value);
          }}
          fullWidth
          value={zipCode} />
      </Grid>
      <Grid item xs={12}>
        <TextField
          variant="standard"
          type={'number'}
          label="Numéro du client"
          onChange={(e) => setTel(e.target.value)}
          fullWidth
          value={tel} />
      </Grid>
      <Grid item xs={12}>
        <TextField
          variant="standard"
          label="Message envoyé au client"
          helperText={
            'Le lien vers la page d\'envoi de photos est ajouté '
            + 'automatiquement à la fin, inutile de l\'écrire ici.'
          }
          multiline
          minRows={3}
          onChange={(e) => setMessage(e.target.value)}
          fullWidth
          value={message} />
      </Grid>
    </Grid>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(DemandePhoto);
